import React, { useEffect, useState ,useRef } from 'react';
import ToggleSwitch from '../toggleswitch/ToggleSwitch';
import axios from 'axios';

const AdminTab = (props) => {
    const [mpPoints, setMpPoints] = useState(0);
    const [succPopUp, setSuccPopUp] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    const popupRef = useRef(succPopUp);
    useEffect(() => {
        popupRef.current = succPopUp;
        const timeout = setTimeout(() => {
            setSuccPopUp("");
        }, 5000);
        return () => {
            clearTimeout(timeout);
        };
    }, [succPopUp]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(window.ajaxLink + "cloud_programs/get-mp-points");
            if (response.data && response.data.responseData.meta_value) {
                var meta_value = +response.data.responseData.meta_value;
                setMpPoints(meta_value);
            } else {
                console.error("Invalid response format:", response);
            }
        } catch (error) {
            console.error("Error fetching Media Pipe Points:", error);
        } finally{
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleToggleMpPoints = () => {
        setMpPoints((prevMpPoints) => (prevMpPoints === 1 ? 0 : 1));
    };

    const handleSave = async () => {
        try {
            setSubmitting(true);
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            await axios.post(window.ajaxLink + "cloud_programs/toggle-mp-points", {
                mpPoints: mpPoints,
            }).then((res) => {
                if (res.data) {
                    if (mpPoints === 1) {
                        setSuccPopUp(`MP Points has been successfully ON.`);
                    } else {
                        setSuccPopUp(`MP Point has been successfully OFF.`);
                    }
                }
            })
        } catch (error) {
            console.error("Error updating Media Pipe Points:", error);
            // console.log("Axios error response:", error.response);
        } finally{
            setSubmitting(false);
        }
    };

    return (
        <div style={{height: "100%", padding: '10px'}}>
            {props.isSuperAdmin && (
                <>
                {
                loading ?
                <div className="programs_table_no_content loading_screen_container">
                    <div className="no_content_notice_contain">
                        <div className="p_load"></div>
                    </div>
                </div>
                :
                <div style={{padding: '0rem 1rem'}}>
                    <h2>Admin Settings</h2>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <label>Show MediaPipe Points</label>
                        <ToggleSwitch
                            value={mpPoints}
                            onChange={handleToggleMpPoints}
                        />
                    </div>
                    <div onClick={handleSave}
                        style={{
                            marginTop: "5px",
                            marginLeft: "0px",
                            textAlign: "center",
                            padding: '16px'
                        }}
                        disabled={submitting}
                        className="save_btn_add_member avail_save_button">
                        {submitting ? "Saving" : "Save"}
                    </div>
                    {succPopUp && (
                        <div className="prog_err_hold prog_pop_pat_correct">
                            <div className="prog_pop_icon_correct prog_err_icon"></div>
                            <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
                        </div>
                    )}
                </div>
                }
                </>
            )}
        </div>
    )
}

export default AdminTab